module.exports = __webpack_public_path__ + "static/media/TipsStiker.b70dc751.png";